module.exports = __webpack_public_path__ + "img/17.e8a55a45.jpeg";